import './settings.scss';

class Settings {
    constructor(element) {
        this.$settings = element;
        this.$settingsLanguageButton = this.$settings.querySelector('[data-settings="lang-btn"]');
        this.$settingsLanguageOptions = this.$settings.querySelector('[data-settings="lang-options"]');
        this.$settingsCountryButton = this.$settings.querySelector('[data-settings="country-btn"]');
        this.$settingsCountryOptions = this.$settings.querySelector('[data-settings="country-options"]');
    }

    initialize() {
        if (this.$settingsLanguageButton) {
            this.$settingsLanguageButton.addEventListener('click', () => {
                this.toggleOptions('language');
            });
        }

        if (this.$settingsCountryButton) {
            this.$settingsCountryButton.addEventListener('click', () => {
                this.toggleOptions('country');
            });
        }
    }

    toggleOptions(option) {
        const isLanguage = option === 'language';
        this.$settingsLanguageOptions.classList.toggle('setting--is-active', isLanguage);
        this.$settingsCountryOptions.classList.toggle('setting--is-active', !isLanguage);
        this.$settingsLanguageButton.classList.toggle('setting--is-active', isLanguage);
        this.$settingsCountryButton.classList.toggle('setting--is-active', !isLanguage);
        this.$settingsLanguageButton.setAttribute('aria-expanded', isLanguage ? 'true' : 'false');
        this.$settingsCountryButton.setAttribute('aria-expanded', !isLanguage ? 'true' : 'false');
    }
}

export {Settings};

window.addEventListener('content.loaded', (e) => {
    const {$context} = e.detail;

    if ($context) {
        const $$settings = $context.querySelectorAll('[data-settings="root"]');

        $$settings.forEach($settingElement => {
            const $settings = new Settings($settingElement);
            $settings.initialize();
        });
    }
});
